module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-37.93209d20.png";